var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconCalendarDaySolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconCalendarDay",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1694.176 451.765H225.942V282.353c0-31.624 24.846-56.471 56.47-56.471h169.411v56.471c0 31.623 24.848 56.471 56.471 56.471 31.624 0 56.471-24.848 56.471-56.471v-56.471h790.589v56.471c0 31.623 24.846 56.471 56.47 56.471 31.623 0 56.47-24.848 56.47-56.471v-56.471h169.412c31.623 0 56.47 24.847 56.47 56.471v169.412Zm-477.74 849.317c0 134.4-105.035 231.529-258.636 231.529-128.753 0-221.364-53.082-283.482-128.752l90.353-83.577c53.082 62.118 112.941 96 195.388 96 72.282 0 127.624-42.917 127.624-109.554v-2.257c0-72.284-66.636-112.942-170.542-112.942h-59.859l-21.459-80.188L1035.73 902.4H716.106V790.588h489.035v96L998.459 1094.4c111.812 13.553 217.977 70.024 217.977 204.423v2.259Zm421.27-1188.141h-169.412v-56.47c0-31.624-24.847-56.471-56.47-56.471-31.624 0-56.47 24.847-56.47 56.471v56.47H564.765v-56.47C564.765 24.847 539.918 0 508.294 0c-31.623 0-56.471 24.847-56.471 56.471v56.47H282.412C188.671 112.941 113 188.612 113 282.353V1920h1694.118V282.353c0-93.741-75.671-169.412-169.412-169.412Z",
      fillRule: "evenodd"
    })));
  }
}
IconCalendarDaySolid.glyphName = 'calendar-day';
IconCalendarDaySolid.variant = 'Solid';
IconCalendarDaySolid.displayName = 'IconCalendarDaySolid';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconCalendarDaySolid.propTypes = {
  ...SVGIcon.propTypes
};
IconCalendarDaySolid.allowedProps = [...SVGIcon.allowedProps];
export default IconCalendarDaySolid;
export { IconCalendarDaySolid };